import { mkConfig, generateCsv, download } from "export-to-csv";

export const exportToCsv = (data: any[], title="vuelve-file") => {
    const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: title, title: title });
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
}